var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "addFast",
          attrs: {
            visible: _vm.addUseTimeBox,
            width: "80%",
            "show-close": false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.addUseTimeBox = $event
            },
          },
        },
        [
          _c("div", { staticClass: "title" }, [
            _c("p", [_vm._v("快速生成预算")]),
            _c("p", [
              _vm._v(
                "(您将按照下方信息生成预算，订单产生后若无后台供应商接单，则订单自动失效)"
              ),
            ]),
          ]),
          _c(
            "ul",
            { staticClass: "order_list" },
            [
              _vm._l(_vm.orderType, function (item, index) {
                return _c("li", { key: index }, [
                  _c("div", { staticClass: "typeDiv" }, [
                    _vm._v(_vm._s(item.type)),
                  ]),
                  item.state != -1
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            width: "20px",
                            height: "19px",
                            cursor: "pointer",
                            margin: "2px 0 2px 4px",
                            "background-color": "#02A0C6",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.addProduct(item)
                            },
                          },
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/png/addService.png"),
                              alt: "",
                              width: "100%",
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                ])
              }),
              _vm.totalPrice.length > 0
                ? _c(
                    "div",
                    { staticStyle: { color: "red", "margin-left": "20px" } },
                    [
                      _vm._v(" 成本总金额："),
                      _vm._l(_vm.totalPrice, function (item, index) {
                        return _c("span", { key: index }, [
                          _vm._v(_vm._s(item.price) + _vm._s(item.currency)),
                        ])
                      }),
                    ],
                    2
                  )
                : _vm._e(),
              _vm.saleTotalPrice.length > 0
                ? _c(
                    "div",
                    { staticStyle: { color: "red", "margin-left": "20px" } },
                    [
                      _vm._v(" 报价总金额："),
                      _vm._l(_vm.saleTotalPrice, function (item, index) {
                        return _c("span", { key: index }, [
                          _vm._v(_vm._s(item.price) + _vm._s(item.currency)),
                        ])
                      }),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            2
          ),
          _c("div", { staticClass: "tableTitle" }, [
            _c(
              "span",
              { staticClass: "label", staticStyle: { width: "1.8rem" } },
              [_vm._v("日期")]
            ),
            _c(
              "span",
              { staticClass: "label", staticStyle: { width: "0.3rem" } },
              [_vm._v("类型")]
            ),
            _c(
              "span",
              { staticClass: "label", staticStyle: { width: "1.5rem" } },
              [_vm._v("资源名称")]
            ),
            _c(
              "span",
              { staticClass: "label", staticStyle: { width: "1.5rem" } },
              [_vm._v("产品名称")]
            ),
            _c(
              "span",
              { staticClass: "label", staticStyle: { width: "1.5rem" } },
              [_vm._v("产品描述")]
            ),
            _c(
              "span",
              { staticClass: "label", staticStyle: { width: "0.6rem" } },
              [_vm._v("单位")]
            ),
            _c(
              "span",
              { staticClass: "label", staticStyle: { width: "0.6rem" } },
              [_vm._v("时长")]
            ),
            _c(
              "span",
              { staticClass: "label", staticStyle: { width: "0.6rem" } },
              [_vm._v("数量")]
            ),
            _c(
              "span",
              { staticClass: "label", staticStyle: { width: "0.6rem" } },
              [_vm._v("币种")]
            ),
            _c(
              "span",
              { staticClass: "label", staticStyle: { width: "0.8rem" } },
              [_vm._v("单项成本")]
            ),
            _c(
              "span",
              { staticClass: "label", staticStyle: { width: "0.8rem" } },
              [_vm._v("单项报价")]
            ),
            _c(
              "span",
              { staticClass: "label", staticStyle: { width: "0.8rem" } },
              [_vm._v("票据号")]
            ),
            _c(
              "span",
              { staticClass: "label", staticStyle: { width: "0.5rem" } },
              [_vm._v("操作")]
            ),
          ]),
          _c(
            "div",
            { staticStyle: { position: "absolute" } },
            _vm._l(_vm.checkBudgetDetail.planDayList, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "dayQuan",
                  style:
                    item.planDay == _vm.checkPlanDay
                      ? "background: #da4e1a;color: #fff;"
                      : "",
                  on: {
                    click: function ($event) {
                      return _vm.goToDay(item.planDay)
                    },
                  },
                },
                [_vm._v("D" + _vm._s(item.planDay))]
              )
            }),
            0
          ),
          _c(
            "div",
            {
              style:
                "display: flex;overflow-y: scroll;margin-left: 0.4rem;height:" +
                _vm.height +
                "px",
            },
            [
              _c(
                "div",
                _vm._l(
                  _vm.checkBudgetDetail.planDayList,
                  function (item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "daybox",
                        style:
                          item.planDay == _vm.checkPlanDay
                            ? "box-shadow: 0px 1px 10px 2px rgba(0, 0, 0, 0.4);"
                            : "",
                        attrs: { id: "changeTimeDay" + item.planDay },
                      },
                      [
                        _c("div", { staticStyle: { width: "1.7rem" } }, [
                          _c("label", [
                            _vm._v(
                              _vm._s(_vm.dateFormatYMD(item.planDate, ".")) +
                                " "
                            ),
                          ]),
                          _c(
                            "label",
                            _vm._l(item.cityList, function (item1, index1) {
                              return _c("span", { key: index1 }, [
                                _vm._v(_vm._s(item1.cityName) + " "),
                                index1 != item.cityList.length - 1
                                  ? _c("span", [_vm._v("-")])
                                  : _vm._e(),
                              ])
                            }),
                            0
                          ),
                        ]),
                        _c(
                          "div",
                          [
                            _c(
                              "draggable",
                              {
                                attrs: { group: "itxst", animation: "300" },
                                on: { add: _vm.addCommand },
                                model: {
                                  value: item.productList,
                                  callback: function ($$v) {
                                    _vm.$set(item, "productList", $$v)
                                  },
                                  expression: "item.productList",
                                },
                              },
                              [
                                _c(
                                  "transition-group",
                                  {
                                    style: _vm.style,
                                    attrs: { id: item.planDate },
                                  },
                                  _vm._l(
                                    item.productList,
                                    function (item1, index1) {
                                      return _c(
                                        "div",
                                        {
                                          key: index + "-" + index1,
                                          staticClass: "productBox",
                                          style:
                                            item.planDay == _vm.checkPlanDay
                                              ? "box-shadow: 0px 1px 10px 2px rgba(0, 0, 0, 0.4);"
                                              : "",
                                          on: {
                                            mouseover: function ($event) {
                                              _vm.checkPlanDay = item.planDay
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "labelone textspan",
                                              staticStyle: { width: "0.3rem" },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(item1.productTypeName)
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "labelone textspan",
                                              staticStyle: { width: "1.5rem" },
                                            },
                                            [
                                              item1.isEdit
                                                ? _c(
                                                    "span",
                                                    [
                                                      _c("el-autocomplete", {
                                                        attrs: {
                                                          "fetch-suggestions": (
                                                            queryString,
                                                            cb
                                                          ) => {
                                                            _vm.querySearchResource(
                                                              queryString,
                                                              cb,
                                                              item
                                                            )
                                                          },
                                                          placeholder:
                                                            "请输入资源名称",
                                                        },
                                                        on: {
                                                          select: function (
                                                            $event
                                                          ) {
                                                            return _vm.handleSelect(
                                                              $event,
                                                              item1
                                                            )
                                                          },
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "default",
                                                              fn: function ({
                                                                item,
                                                              }) {
                                                                return [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "name",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          item.nameCn &&
                                                                            item.nameCn !=
                                                                              ""
                                                                            ? item.nameCn
                                                                            : item.nameEn
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              },
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                        model: {
                                                          value:
                                                            item1.resourceNameCn,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item1,
                                                              "resourceNameCn",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item1.resourceNameCn",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        item1.resourceNameCn
                                                      )
                                                    ),
                                                  ]),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "labelone textspan",
                                              staticStyle: { width: "1.5rem" },
                                            },
                                            [
                                              item1.isEdit
                                                ? _c(
                                                    "span",
                                                    [
                                                      _c(
                                                        "el-select",
                                                        {
                                                          attrs: {
                                                            placeholder:
                                                              "请输入产品名称",
                                                            filterable: "",
                                                            "allow-create": "",
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              return _vm.changeSelect(
                                                                $event,
                                                                item1
                                                              )
                                                            },
                                                          },
                                                          model: {
                                                            value:
                                                              item1.details[0]
                                                                .productName,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                item1
                                                                  .details[0],
                                                                "productName",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item1.details[0].productName",
                                                          },
                                                        },
                                                        _vm._l(
                                                          item1.checkProductList,
                                                          function (
                                                            item2,
                                                            index2
                                                          ) {
                                                            return _c(
                                                              "el-option",
                                                              {
                                                                key: index2,
                                                                attrs: {
                                                                  value:
                                                                    item2.stockId,
                                                                  label:
                                                                    item2.budgetType +
                                                                    item2.productNameCn +
                                                                    item2.productDesc +
                                                                    item2.stockDesc +
                                                                    (item2
                                                                      .priceList
                                                                      .length >
                                                                    0
                                                                      ? item2
                                                                          .priceList[0]
                                                                          .price +
                                                                        item2
                                                                          .priceList[0]
                                                                          .currency +
                                                                        item2
                                                                          .priceList[0]
                                                                          .priceCompany +
                                                                        item2
                                                                          .priceList[0]
                                                                          .useTime
                                                                      : ""),
                                                                },
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        item1.details[0]
                                                          .productName
                                                      )
                                                    ),
                                                  ]),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "labelone textspan",
                                              staticStyle: { width: "1.5rem" },
                                            },
                                            [
                                              item1.isEdit
                                                ? _c(
                                                    "span",
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          placeholder: "请输入",
                                                        },
                                                        model: {
                                                          value:
                                                            item1.details[0]
                                                              .stockDetailObj
                                                              .productDesc,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item1.details[0]
                                                                .stockDetailObj,
                                                              "productDesc",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item1.details[0].stockDetailObj.productDesc",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        item1.details[0]
                                                          .stockDetailObj
                                                          .productDesc
                                                      )
                                                    ),
                                                  ]),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "labelone textspan",
                                              staticStyle: { width: "0.6rem" },
                                            },
                                            [
                                              item1.isEdit
                                                ? _c(
                                                    "span",
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          placeholder: "请输入",
                                                        },
                                                        model: {
                                                          value:
                                                            item1.details[0]
                                                              .stockDetailObj
                                                              .priceList[0]
                                                              .priceCompany,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item1.details[0]
                                                                .stockDetailObj
                                                                .priceList[0],
                                                              "priceCompany",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item1.details[0].stockDetailObj.priceList[0].priceCompany",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        item1.details[0]
                                                          .stockDetailObj
                                                          .priceList[0]
                                                          .priceCompany
                                                      )
                                                    ),
                                                  ]),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "labelone textspan",
                                              staticStyle: { width: "0.6rem" },
                                            },
                                            [
                                              item1.isEdit
                                                ? _c(
                                                    "span",
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          placeholder: "请输入",
                                                        },
                                                        model: {
                                                          value:
                                                            item1.details[0]
                                                              .stockDetailObj
                                                              .priceList[0]
                                                              .useTime,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item1.details[0]
                                                                .stockDetailObj
                                                                .priceList[0],
                                                              "useTime",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item1.details[0].stockDetailObj.priceList[0].useTime",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        item1.details[0]
                                                          .stockDetailObj
                                                          .priceList[0].useTime
                                                      )
                                                    ),
                                                  ]),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "labelone textspan",
                                              staticStyle: { width: "0.6rem" },
                                            },
                                            [
                                              item1.isEdit
                                                ? _c(
                                                    "span",
                                                    [
                                                      _c("el-input", {
                                                        staticClass:
                                                          "def-input-number",
                                                        attrs: {
                                                          type: "number",
                                                          min: "1",
                                                          step: "1",
                                                          placeholder: "请输入",
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.changePrice()
                                                          },
                                                        },
                                                        model: {
                                                          value:
                                                            item1.details[0]
                                                              .stockNumber,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item1.details[0],
                                                              "stockNumber",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item1.details[0].stockNumber",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        item1.details[0]
                                                          .stockNumber
                                                      )
                                                    ),
                                                  ]),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "labelone textspan",
                                              staticStyle: { width: "0.6rem" },
                                            },
                                            [
                                              item1.isEdit
                                                ? _c(
                                                    "span",
                                                    [
                                                      _c(
                                                        "currency-autocomplete",
                                                        {
                                                          attrs: {
                                                            obj: item1
                                                              .details[0],
                                                          },
                                                        }
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        item1.details[0]
                                                          .currency
                                                      )
                                                    ),
                                                  ]),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "labelone textspan",
                                              staticStyle: { width: "0.8rem" },
                                            },
                                            [
                                              item1.isEdit
                                                ? _c(
                                                    "span",
                                                    [
                                                      _c("el-input", {
                                                        staticClass:
                                                          "def-input-number",
                                                        attrs: {
                                                          type: "number",
                                                          placeholder: "请输入",
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.changePrice()
                                                          },
                                                        },
                                                        model: {
                                                          value:
                                                            item1.details[0]
                                                              .stockPrice,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item1.details[0],
                                                              "stockPrice",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item1.details[0].stockPrice",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        item1.details[0]
                                                          .stockPrice
                                                      )
                                                    ),
                                                  ]),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "labelone textspan",
                                              staticStyle: { width: "0.8rem" },
                                            },
                                            [
                                              item1.isEdit
                                                ? _c(
                                                    "span",
                                                    [
                                                      _c("el-input", {
                                                        staticClass:
                                                          "def-input-number",
                                                        attrs: {
                                                          type: "number",
                                                          placeholder: "请输入",
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.changePrice()
                                                          },
                                                        },
                                                        model: {
                                                          value:
                                                            item1.details[0]
                                                              .ratio,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item1.details[0],
                                                              "ratio",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item1.details[0].ratio",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        item1.details[0].ratio
                                                      )
                                                    ),
                                                  ]),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "labelone textspan",
                                              staticStyle: { width: "0.8rem" },
                                            },
                                            [
                                              item1.isEdit
                                                ? _c(
                                                    "span",
                                                    [
                                                      _c("el-input", {
                                                        staticClass:
                                                          "def-input-number",
                                                        attrs: {
                                                          placeholder: "请输入",
                                                        },
                                                        model: {
                                                          value:
                                                            item1.details[0]
                                                              .stockDetailObj
                                                              .billNumber,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item1.details[0]
                                                                .stockDetailObj,
                                                              "billNumber",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item1.details[0].stockDetailObj.billNumber",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        item1.details[0]
                                                          .stockDetailObj
                                                          .billNumber
                                                      )
                                                    ),
                                                  ]),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "labelone textspan",
                                              staticStyle: { width: "0.6rem" },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-document-copy",
                                                staticStyle: {
                                                  "font-size": "0.2rem",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.copyData(item1)
                                                  },
                                                },
                                              }),
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-circle-close",
                                                staticStyle: {
                                                  "font-size": "0.2rem",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.delData(
                                                      item.productList,
                                                      index1,
                                                      item1
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    )
                  }
                ),
                0
              ),
            ]
          ),
          _c(
            "div",
            {
              staticStyle: {
                "justify-content": "center",
                display: "flex",
                padding: "0.1rem",
              },
            },
            [
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "savebuttom",
                      attrs: { loading: _vm.addUseTimeLoading },
                      on: { click: _vm.addUseTime },
                    },
                    [_vm._v("保存")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "savebuttom",
                      staticStyle: { "margin-left": "75px" },
                      on: { click: _vm.closeDialog },
                    },
                    [_vm._v("关闭")]
                  ),
                ],
                1
              ),
            ]
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.copyToOtherDay, width: "12%" },
          on: {
            "update:visible": function ($event) {
              _vm.copyToOtherDay = $event
            },
          },
        },
        [
          _c(
            "el-checkbox",
            {
              on: { change: _vm.allCheck },
              model: {
                value: _vm.checkDayListFlag,
                callback: function ($$v) {
                  _vm.checkDayListFlag = $$v
                },
                expression: "checkDayListFlag",
              },
            },
            [_vm._v("全选")]
          ),
          _c(
            "el-checkbox-group",
            {
              model: {
                value: _vm.checkDayList,
                callback: function ($$v) {
                  _vm.checkDayList = $$v
                },
                expression: "checkDayList",
              },
            },
            _vm._l(_vm.checkBudgetDetail.planDayList, function (item, index) {
              return _c(
                "div",
                { key: index },
                [
                  _c("el-checkbox", { attrs: { label: item.planDay } }, [
                    _vm._v(
                      "D" +
                        _vm._s(item.planDay) +
                        " " +
                        _vm._s(_vm.dateFormatYMD(item.planDate, "."))
                    ),
                  ]),
                ],
                1
              )
            }),
            0
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.copyToOtherDay = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.sureCopy } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }